import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported } from "firebase/analytics";
import { firebaseConfig } from "../firebase-config";

let app;

const startAnalytics = async () => {
  if (typeof window !== "undefined") {
    if (app) {
      return getAnalytics(app);
    }
    // browser code
    const result = await isSupported();
    if (result) {
      app = initializeApp(firebaseConfig);
      return getAnalytics(app);
    }
  }
};

export default startAnalytics;
